import React from 'react';
import CustomerError from '../../../components/CustomerError';
import {UserType} from '../../../hooks/apis/useUser';
import ContestEditForm, {IContestEditForm} from '../../../components/Contest/EditForm';
import UseContest from '../../../hooks/apis/useContest';
import {Breadcrumb, Card, message} from 'antd';
import QuickRouter from '../../../utils/QuickRouter';
import useQuickRouter from '../../../utils/QuickRouter';
import useAuth from '../../../utils/AuthContext';
import CommonApiErrorHandler from '../../../utils/HttpInstance';

export default function ManageContestNewPage() {
  const auth = useAuth();
  const saveState = UseContest.save();
  const quickRouter = useQuickRouter();

  function save(form: IContestEditForm) {
    saveState
      .request(form)
      .then(() => {
        message.success('操作成功');
        return quickRouter.manageContestList();
      })
      .catch(CommonApiErrorHandler);
  }

  if (!auth.currentUser || auth.currentUser.type !== UserType.管理员) return <CustomerError title={'无操作权限'} />;
  return (
    <div>
      <Breadcrumb className={'mb-md'}>
        <Breadcrumb.Item>
          <a onClick={quickRouter.index}>首页</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a onClick={quickRouter.manageContestList}>活动列表</a>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card title={'创建活动'}>
        <ContestEditForm isLoading={saveState.loading} onFinish={save} />
      </Card>
    </div>
  );
}
